import type { AppProceduresInfo } from '@/server/root';

export const trpcProcedures: AppProceduresInfo = {
  'asset.list': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "asset",
  "file": "asset.router.ts"
},
  'content.about': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "content",
  "file": "content.router.ts"
},
  'content.resume': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "content",
  "file": "content.router.ts"
},
  'content.skills': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "content",
  "file": "content.router.ts"
},
  'content.stack': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "content",
  "file": "content.router.ts"
},
  'content.testimonials': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "content",
  "file": "content.router.ts"
},
  'email.send': {
  "meta": {},
  "isPublic": true,
  "type": "mutation",
  "router": "email",
  "file": "email.router.ts"
},
  'github.contributions': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "github",
  "file": "github.router.ts"
},
  'github.readme': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "github",
  "file": "github.router.ts"
},
  'github.repos': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "github",
  "file": "github.router.ts"
},
  'note.allSlugs': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "note",
  "file": "note.router.ts"
},
  'note.authorBySlug': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "note",
  "file": "note.router.ts"
},
  'note.bySlug': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "note",
  "file": "note.router.ts"
},
  'note.count': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "note",
  "file": "note.router.ts"
},
  'note.homepage': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "note",
  "file": "note.router.ts"
},
  'note.list': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "note",
  "file": "note.router.ts"
},
  'note.sitemap': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "note",
  "file": "note.router.ts"
},
  'note.tags': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "note",
  "file": "note.router.ts"
},
  'project.allSlugs': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "project",
  "file": "project.router.ts"
},
  'project.bySlug': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "project",
  "file": "project.router.ts"
},
  'project.count': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "project",
  "file": "project.router.ts"
},
  'project.descriptionBySlug': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "project",
  "file": "project.router.ts"
},
  'project.homepage': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "project",
  "file": "project.router.ts"
},
  'project.homepageImages': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "project",
  "file": "project.router.ts"
},
  'project.list': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "project",
  "file": "project.router.ts"
},
  'project.metadataBySlug': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "project",
  "file": "project.router.ts"
},
  'project.sitemap': {
  "meta": {},
  "isPublic": true,
  "type": "query",
  "router": "project",
  "file": "project.router.ts"
},
};
